"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CtaSectionStyled_1 = __importDefault(require("./CtaSectionStyled"));
const PosaTemplate_1 = __importDefault(require("./PosaTemplate"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const CtaSection = ({ data, ctaAction }) => {
    const { bgImage, cta, leftImage, rightContent } = data;
    return (react_1.default.createElement(CtaSectionStyled_1.default, { className: "ecr-ctaSection" },
        react_1.default.createElement("img", { className: "bg-image", src: bgImage, alt: "background" }),
        react_1.default.createElement("div", { className: "ecrcs-left" },
            react_1.default.createElement("img", { src: leftImage, alt: "asset" })),
        react_1.default.createElement("div", { className: "ecrcs-right" },
            react_1.default.createElement("div", { className: "ecrcs-content" },
                react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, string: rightContent }),
                react_1.default.createElement("button", { onClick: ctaAction }, cta.textOne)))));
};
CtaSection.propTypes = {
    data: prop_types_1.default.object,
    ctaAction: prop_types_1.default.func
};
exports.default = CtaSection;
//# sourceMappingURL=CtaSection.js.map